import { formatDate } from '@angular/common';
import { StateDto } from '../shared/models/state.dto';
import { UserData } from '../shared/models/user.model';
import { SessionService } from '../shared/services/session.service';
import { GolfTechType } from '../shared/models/golftech-type.enum';
import { GOLFTECH_TYPES } from '../shared/constants/globals';
import { StringHelpers } from '../shared/helpers/string-helpers';
import { environment } from 'src/environments/environment';
import { FormGroup } from '@angular/forms';

export class BaseComponent {
  public isDarkMode: boolean = false;
  public isLoading: boolean = false;
  public stateDto: StateDto = { state: "MI" };
  public displayedColumns: String[] = [];
  public searchKey: number;
  public selectedIteration: any;
  public selectedOuting: any;

  constructor(public sessionService: SessionService,
    protected stringHelpers: StringHelpers) { }

  public getUserIdFromSession() {
    return this.sessionService.getUserId();
  }

  public getUserFromSession(): UserData {
    return this.sessionService.getUser();
  }

  public setSearchKey(value: any) {
    this.searchKey = Date.parse(new Date().toString())
    this.sessionService.setSearchKey(this.searchKey, value);
  }

  public setSearchKeyValue(value: any) {
    this.sessionService.setSearchKey(this.searchKey, value);
  }

  public getSearchKey(key: any): any {
    return this.sessionService.getSearchKey(key);
  }

  public setGlobalOuting(outing: any) {
    this.sessionService.setGlobalOuting(outing);
  }

  public getGlobalOuting(): any {
    return this.sessionService.getGlobalOuting();
  }

  public isGlobalOutingSet(): boolean {
    let globalOuting = this.sessionService.getGlobalOuting();
    let globalOutingIteration = this.sessionService.getGlobalOutingIteration();
    return globalOuting !== undefined && globalOuting !== null && globalOutingIteration !== undefined && globalOutingIteration !== null;
  }

  public setGlobalOutingIteration(iteration) {
    this.sessionService.setGlobalOutingIteration(iteration);
  }

  public getGlobalOutingIteration(): any {
    return this.sessionService.getGlobalOutingIteration();
  }

  checkIterationDate(): boolean {
    if (formatDate(new Date(), 'yyyy-MM-dd', 'en_US') > this.selectedIteration.startDate.toString()) {
      return false;
    } else {
      return true;
    }
  }

  golfTechTypeDisplayName(type: string | GolfTechType): string {
    let value;
    switch (type) {
      case GOLFTECH_TYPES.ORGANIZER: {
        value = 'Organizer';
        break;
      }
      case GOLFTECH_TYPES.GOLFER:{
        value = 'Golfer';
        break;
      }
      case GOLFTECH_TYPES.COURSE:{
        value = 'Course';
        break;
      }
      case GOLFTECH_TYPES.GLOBAL_ADMIN:{
        value = 'Global Admin'
        break;
      }
      case GolfTechType.Organizer:{
        value = 'Organizer'
        break;
      }
      case GolfTechType.Golfer :{
        value = 'Golfer'
        break;
      }
      case GolfTechType.Course:{
        value = 'Course'
        break;
      }
      case GolfTechType.GlobalAdmin:{
        value = 'Global Admin'
        break;
      }
      default: {
        value = 'Error: Unknown';
        break;
      }
    }

    return value;
  }

  compareObjects(obj1: any, obj2: any): boolean {
    let value: boolean = false;
    if (obj1 !== null && obj1 !== undefined && obj2 !== null && obj2 !== undefined) {
      value = obj1.id === obj2.id;
    }
    return value;
  }

  setError(err: any, form: any){
    if (err.status === 400) {
      const validationErrors = err.error.errors;

      Object.keys(validationErrors).forEach(prop => {
        const formControl = form.get(this.stringHelpers.camelize(prop));

        if (formControl) {
          formControl.setErrors({ validationErrors: validationErrors[prop] });
        }
      });
    }
  }

  setErrorV2(err: any, form: FormGroup){
    if (err.status === 400) {
      const validationErrors = err.error;

      validationErrors.forEach(prop => {
        const formControl = form.get(this.stringHelpers.camelize(prop.propertyName));
        if (formControl) {
          formControl.setErrors({ validationErrors: prop.errorMessage });
        }
      });
    }
  }

  isNullOrEmpty(data) {
    if (this.stringHelpers.isEmptyOrNull(data)) {
      return true;
    }

    return false;
  }

  canAccess(permission): boolean {
    if(environment.stripe.tierExemptAccounts.includes(this.getUserFromSession().stripeAccountId)){
      return true;
    }
    return permission;
  }
}